import React from "react";
import styled from "styled-components";
import { maxLengthCheck } from "../../../views/common/maxLengthCheck/maxLengthCheck";
import { getCookie } from "../../../modules/utils/cookie";
import { returnTime } from "../../../views/Membership/CheckCertiNo";

export const InputDivAttch2 = (props) => {
  const {
    type,
    name,
    maxLength,
    focusEvent,
    blurEvent,
    onChange,
    inputState,
    placeholder,
    defaultValue,
    errorText,
    clickEvent,
    pattern,
    requestCertiNo,
  } = props;

  const statusBorderColor = (inputState) => {
    if (inputState == "E") return "RED";
    if (inputState == "G") return "GREEN";

    return "#d0d0d0";
  };

  return (
    <div style={props.style}>
      <InputDataForm borderColor="#f7f7f7">
        <div style={{ display: "flex", height: "100%" }}>
          <InputInvisible
            type={type}
            name={name}
            placeholder={placeholder}
            pattern={pattern ? pattern : ""}
            defaultValue={defaultValue}
            onChange={(e) =>
              onChange
                ? type == "number"
                  ? maxLengthCheck(maxLength, e)
                  : onChange("I", e.target.value)
                : ""
            }
            maxLength={maxLength ? maxLength : ""}
          />

          {requestCertiNo &&
            (getCookie("timer") > 0 ? (
              <div
                style={{
                  float: "right",
                  lineHeight: "48px",
                }}
              >
                {returnTime(getCookie("timer"))}
              </div>
            ) : (
              <div
                style={{
                  float: "right",
                  border: "1px solid #b0b0b0",
                  borderRadius: "8px",
                  padding: "4px 8px",
                  width: "97px",
                  height: "32px",
                  marginTop: "3px",
                  marginRight: "-10px",
                  textAlign: "center",
                  lineHeight: "32px",
                  background: "#6200EE",
                  color: "#fff",
                }}
                onClick={() => requestCertiNo()}
              >
                재전송요청
              </div>
            ))}
        </div>
      </InputDataForm>
    </div>
  );
};

const InputDataForm = styled.div`
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 8px;
  padding: 0px 15px;
  height: 48px;
`;

const InputInvisible = styled.input`
  border: 0px;
  width: 100%;
  height: 100%;
  background-color: #f7f7f7;
`;
